import React, { Component } from "react";
import autobind from "autobind-decorator";
import DocumentTitle from "components/Global/DocumentTitle";
import SignupActions from "actions/Global/SignupActions";
import ViewWrapper from "../ViewWrapper";
import CSSModules from "react-css-modules";
import css from "./styles.scss";
import PasswordField from "components/Global/Inputs/Password";
import PasswordChecklist from "react-password-checklist";
import * as R from "ramda";
import PasswordChecklistConfig from "utils/password-checklist-config";

@CSSModules(css)
class ResetPasswordHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      complete: false,
      message: this.props.location.query.message || null,
      password: "",
      isPasswordValid: false
    };
  }

  @autobind
  handlePasswordChange(event) {
    /**
     * Trim the password on change, not on submit
     */
    const password = R.path(["target", "value"], event).trim();
    this.setState({ password });
  }

  @autobind
  handleSubmit(event) {
    event.preventDefault();
    const { complete, password, isPasswordValid } = this.state;
    const hash = R.path(["props", "params", "hash"], this);

    if (!password || complete || !isPasswordValid) {
      return;
    }

    this.setState(
      {
        message: "One moment, please. We're updating your info...",
        isPasswordValid: false
      },
      () => this.resetPassword(hash, password)
    );
  }

  @autobind
  resetPassword(hash, password) {
    SignupActions.resetPassword(hash, password, result => {
      if (result.success) {
        /**
         * Reset state, redirect to login
         */
        const { router } = this.props;
        this.setState(
          {
            message: null,
            complete: true,
            isPasswordValid: false
          },
          () =>
            router.push({
              pathname: "/login",
              query: {
                message:
                  "Your password has been reset. Please login with your information."
              }
            })
        );
      } else {
        this.setState({
          isPasswordValid: true,
          message: (
            <span>
              {result.message}. Try again or{" "}
              <a href="mailto:support@sessionboard.com">shoot us a message</a>.
            </span>
          )
        });
      }
    });
  }

  render() {
    const { message, password, isPasswordValid } = this.state;
    return (
      <DocumentTitle title="Reset Password">
        <ViewWrapper>
          <form method="post" onSubmit={this.handleSubmit}>
            <div styleName="formBody">
              <div styleName="title">Reset Password</div>
              <div styleName="caption">
                Enter a new password for your user account
              </div>
              <div styleName="inputWrapper">
                <PasswordField
                  autoFocus
                  className="styled"
                  name="email"
                  onChange={this.handlePasswordChange}
                  placeholder="Password"
                  required
                  type="password"
                  value={password}
                />
              </div>
              <div
                style={{
                  marginTop: "5px",
                  marginBottom: "10px",
                  fontSize: "14px",
                  color: "#222"
                }}
              >
                <PasswordChecklist
                  iconSize={12}
                  rules={["minLength", "specialChar", "number", "capital"]}
                  minLength={8}
                  value={password}
                  onChange={isValid => {
                    if (isValid !== isPasswordValid) {
                      this.setState({ isPasswordValid: isValid });
                    }
                  }}
                  messages={PasswordChecklistConfig}
                />
              </div>
              {message && <div styleName="message">{message}</div>}
              <button
                styleName="buttonWrapper"
                type="submit"
                {...(!isPasswordValid && {
                  disabled: true,
                  style: { backgroundColor: "darkgray", cursor: "not-allowed" }
                })}
              >
                <span styleName="button">Reset Password</span>
              </button>
            </div>
          </form>
        </ViewWrapper>
      </DocumentTitle>
    );
  }
}

export default ResetPasswordHandler;
